import { render, staticRenderFns } from "./consumer.vue?vue&type=template&id=b9cf15b0&scoped=true"
import script from "./consumer.vue?vue&type=script&lang=js"
export * from "./consumer.vue?vue&type=script&lang=js"
import style0 from "./consumer.vue?vue&type=style&index=0&id=b9cf15b0&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cf15b0",
  null
  
)

export default component.exports